import { useMemo } from 'react';

import {
  resolveCompactSummary,
  type CompactSummaryInput,
  type CompactSummaryResult,
} from '../core/resolveCompactSummary';

export const useCompactSummary = (input: CompactSummaryInput): CompactSummaryResult =>
  useMemo(
    () => resolveCompactSummary(input),
    [
      input.source,
      input.transactable.directLink,
      input.cart,
      input.cartSummary,
      input.orderSummary,
      input.saleSummary,
      input.saleChangeSummary,
      input.purchaseSummary,
    ],
  );

export default useCompactSummary;
